import { useEffect, useState, type ReactNode } from "react";
import { currentAccount, type AccountData } from "@/api/session";
import { Spinner } from "@/components/ui/spinner";

export function RequireAuth({ children, ownerOnly = false }: { children: ReactNode; ownerOnly?: boolean }) {
  const [account, setAccount] = useState<AccountData | null>(null);
  const [error, setError] = useState<Error | null>(null);
  useEffect(() => {
    const controller = new AbortController();
    currentAccount(controller.signal).then((verified) => {
      if (controller.signal.aborted) return;
      if (verified) setAccount(verified);
      else window.location.replace("/login");
    }).catch((failure: unknown) => {
      if (!controller.signal.aborted) setError(failure instanceof Error ? failure : new Error("Unable to verify your account"));
    });
    return () => controller.abort();
  }, []);
  if (error) return <main role="alert">{error.message}<button onClick={() => window.location.reload()}>Retry</button></main>;
  if (!account) return <Spinner />;
  if (ownerOnly && !(account.role === "owner" && account.status === "active")) {
    return <main role="alert">Access denied. Only the account owner can open this page.<a href="/chat">Back to chat</a></main>;
  }
  return children;
}
